<div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="center center">
    <mat-card fxLayout="column" fxLayoutAlign="center stretch" class="loading-inputs">
        <app-skeleton></app-skeleton>
    </mat-card>
    <mat-card fxLayout="column" fxLayoutAlign="center stretch" class="loading-inputs">
        <app-skeleton></app-skeleton>
    </mat-card>
</div>
